<template>
  <el-container class="layout-container">
    <el-aside width="200px">
      <div class="logo">
        <i class="el-icon-connection"></i>
        <span>物联网管理</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
      >
        <el-menu-item index="/reports">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/devices">
          <i class="el-icon-s-grid"></i>
          <span slot="title">设备列表</span>
        </el-menu-item>
        <el-menu-item index="/device-types">
          <i class="el-icon-document-add"></i>
          <span slot="title">设备类型</span>
        </el-menu-item>
        <el-menu-item index="/templates">
          <i class="el-icon-s-tools"></i>
          <span slot="title">设备模板</span>
        </el-menu-item>
        <el-menu-item index="/firmwares">
          <i class="el-icon-upload2"></i>
          <span slot="title">固件管理</span>
        </el-menu-item>
        <el-menu-item index="/rules">
          <i class="el-icon-s-operation"></i>
          <span slot="title">规则配置</span>
        </el-menu-item>
        <el-menu-item index="/alarms">
          <i class="el-icon-warning"></i>
          <span slot="title">告警记录</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <div class="header-content">
          <span class="title">物联网设备管理系统</span>
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user"></i>
              <span>管理员</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="changePasswordDialogVisible" width="450px" :close-on-click-modal="false" @close="resetForm">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
          <div class="password-strength">
            <div class="strength-item" :class="{ active: passwordForm.newPassword.length >= 6 }">弱</div>
            <div class="strength-item" :class="{ active: passwordForm.newPassword.length >= 8 && hasLetter && hasNumber }">中</div>
            <div class="strength-item" :class="{ active: passwordForm.newPassword.length >= 10 && hasLetter && hasNumber && hasSpecial }">强</div>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="changePasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleChangePassword">{{ loading ? '提交中...' : '确定' }}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    const validateNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度至少6位'))
      } else if (value.length < 8) {
        callback(new Error('建议密码长度至少8位'))
      } else {
        callback()
      }
    }
    return {
      changePasswordDialogVisible: false,
      loading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validateNewPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    hasLetter() {
      return /[a-zA-Z]/.test(this.passwordForm.newPassword)
    },
    hasNumber() {
      return /[0-9]/.test(this.passwordForm.newPassword)
    },
    hasSpecial() {
      return /[!@#$%^&*(),.?":{}|<>]/.test(this.passwordForm.newPassword)
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.logout()
        }).catch(() => {})
      } else if (command === 'profile') {
        this.$message.info('个人中心')
      } else if (command === 'password') {
        this.showChangePasswordDialog()
      }
    },
    logout() {
      const token = localStorage.getItem('token')
      if (token) {
        this.$http.post('/api/auth/logout', { token: token }).catch(() => {})
      }
      localStorage.clear()
      sessionStorage.clear()
      this.$message.success('已退出登录')
      this.$router.push('/login')
    },
    showChangePasswordDialog() {
      this.changePasswordDialogVisible = true
    },
    resetForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.$refs.passwordForm.resetFields()
    },
    handleChangePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          const pwd = this.passwordForm.newPassword
          const checks = [
            pwd.length >= 6,
            pwd.length >= 8 && /[a-zA-Z]/.test(pwd) && /[0-9]/.test(pwd),
            pwd.length >= 10 && /[a-zA-Z]/.test(pwd) && /[0-9]/.test(pwd) && /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
          ]
          const strength = checks.filter(Boolean).length
          if (strength < 2) {
            this.$message.warning('密码强度不足，建议使用字母、数字和特殊字符组合')
          }
          
          this.loading = true
          const token = localStorage.getItem('token') || sessionStorage.getItem('token')
          this.$http.post('/api/auth/change-password', {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword,
            token: token
          }).then(() => {
            this.$message.success('密码修改成功，请重新登录')
            this.changePasswordDialogVisible = false
            setTimeout(() => {
              this.logout()
            }, 1000)
          }).catch(err => {
            this.$message.error(err.message || '密码修改失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.el-aside {
  background-color: #304156;
  overflow-x: hidden;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background-color: #2b3a4a;
}

.logo i {
  font-size: 24px;
  vertical-align: middle;
  margin-right: 8px;
}

.el-menu-vertical {
  border-right: none;
}

.el-header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.header-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}

.user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.el-main {
  background-color: #f0f2f5;
  padding: 20px;
}

.password-strength {
  display: flex;
  gap: 5px;
  margin-top: 5px;
}

.strength-item {
  flex: 1;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  font-size: 10px;
  text-align: center;
  line-height: 4px;
  color: #999;
}

.strength-item.active:first-child {
  background: #F56C6C;
}

.strength-item.active:nth-child(2) {
  background: #E6A23C;
}

.strength-item.active:last-child {
  background: #67C23A;
}
</style>
